<!--
 * @Author: owen
 * @Date: 2022-04-11 14:35:25
 * @LastEditors: owen
 * @LastEditTime: 2022-04-27 15:51:58
 * @FilePath: \app-pcweb\src\components\PopupDialog\index.vue
-->
<template>
  <el-dialog
    v-if="show"
    :id="iddialogbox ? '' : 'dialog'"
    :class="['pop-dialog', className]"
    :visible.sync="show"
    :width="width"
    :lock-scroll="lockScroll"
    :append-to-body="true"
    :fullscreen="fullscreen"
    :close-on-press-escape="false"
    :show-close="false"
    destroy-on-close
    :top="top"
    :close-on-click-modal="false"
  >
    <template slot="title">
      <div
        v-if="!dataOpt.hideHead"
        class="title-box"
        :class="{
          isInTelegramWebApp: isInTelegramWebApp,
        }"
      >
        <span
          class="return el-icon-arrow-left"
          v-if="dataOpt.showReturn"
          @click.stop="close($event)"
          @touchend.stop="close($event)"
        ></span>
        <span v-if="dataOpt.title">{{ dataOpt.title }}</span>
        <span
          class="close el-icon-close"
          v-if="!dataOpt.hideClose"
          @click.stop="close($event)"
          @touchend.stop="close($event)"
        ></span>
      </div>
    </template>
    <div class="center-box">
      <slot name="center"></slot>
    </div>
  </el-dialog>
</template>
<script>
import PopupDialog from "@/lobby_common/mixins_components/PopupDialog/index.js";
export default {
  components: {},
  props: [],
  mixins: [PopupDialog],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  max-width: 100% !important;
  background: var(--popup-100);
  border-radius: 10px;

  &.is-fullscreen {
    border-radius: 0px;
    .title-box {
      @include textOverflow(1);
      &.isInTelegramWebApp {
        padding-top: calc(var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px));
        .close,
        .return {
          top: calc(50% + (var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px)) / 2);
        }
      }
      .close,
      .return {
        top: 50%;
      }
    }
  }

  .el-dialog__header {
    padding: 0 20px 10px;
  }

  .el-dialog__body {
    padding: 0 20px 20px;
  }
}

.title-box {
  position: relative;
  height: 56px;
  line-height: 56px;
  text-align: center;
  font-size: 24px;
  font-weight: normal;
  white-space: nowrap;
  border-bottom: 1px solid var(--border-color-200);
  @media (max-width: 768px) {
    font-size: 18px;
  }
}

.close {
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
  color: var(--font-color-100);
  font-size: 20px;
  cursor: pointer;
}

.return {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  color: #f1f1f1bb;
  font-size: 32px;
  cursor: pointer;
}
</style>
<style lang="scss">
@media (max-width: 768px) {
  #dialog .el-dialog {
    width: 90% !important;
  }
  #dialog.widthP80 .el-dialog {
    width: 80% !important;
  }
  #dialog.widthP90 .el-dialog {
    width: 90% !important;
  }
  #dialog .el-dialog.is-fullscreen {
    width: 100% !important;
  }
}
.userDialog-wrap .el-dialog {
  .el-dialog__header {
    padding: 0 40px 10px;
    @media (min-width: 768px) {
      .close {
        right: -30px;
      }
    }
    @media (max-width: 768px) {
      padding: 0 20px 10px;
    }
  }
  .el-dialog__body {
    padding: 0 0 20px;
  }
}
.home-activity-dialog .el-dialog,
.resultDialog-dialog .el-dialog {
  background: transparent !important;
  box-shadow: none;
  .title-box {
    display: none;
  }
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
// .resultDialog-dialog.el-dialog__wrapper {
//   background: rgba($color: #000000, $alpha: 0.7) !important;
// }

.hidden-close .el-dialog {
  .title-box {
    display: none;
  }
}
</style>
